var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 675.26 676.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #fff;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #4e6283;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "graphic"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fiveInOne"
  }, /*#__PURE__*/React.createElement("g", {
    id: "timer"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 209.67,
    y: 210.82,
    width: 254.92,
    height: 254.92
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 209.67,
    y1: 210.82,
    x2: 277.66,
    y2: 278.81
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "272.42 279.36 272.46 278.36 277.39 278.54 277.21 273.61 278.21 273.57 278.42 279.58 272.42 279.36"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 464.59,
    y1: 210.82,
    x2: 396.6,
    y2: 278.81
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "396.05 273.57 397.05 273.61 396.87 278.54 401.8 278.36 401.84 279.36 395.83 279.57 396.05 273.57"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 209.67,
    y1: 465.74,
    x2: 277.66,
    y2: 397.75
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "278.21 402.99 277.21 402.95 277.39 398.02 272.46 398.2 272.42 397.2 278.43 396.99 278.21 402.99"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 464.59,
    y1: 465.74,
    x2: 396.6,
    y2: 397.75
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "401.84 397.2 401.8 398.2 396.87 398.02 397.05 402.95 396.05 402.99 395.84 396.98 401.84 397.2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "gravity"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m63.68,64.83v548.04h548.04V64.83H63.68Zm402.26,401.61h-255.77v-255.77h255.77v255.77Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "465.94 141.74 360.56 141.74 360.56 96.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "364.65 100.21 363.92 100.89 360.56 97.28 357.2 100.89 356.47 100.21 360.56 95.81 364.65 100.21"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "205.29 141.74 313.2 141.74 313.2 96.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "317.29 100.21 316.56 100.89 313.2 97.28 309.85 100.89 309.11 100.21 313.2 95.81 317.29 100.21"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "465.94 532.02 360.56 532.02 360.56 576.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "356.47 573.55 357.2 572.86 360.56 576.48 363.92 572.86 364.65 573.55 360.56 577.94 356.47 573.55"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "205.29 532.02 313.2 532.02 313.2 576.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "309.11 573.55 309.84 572.86 313.2 576.48 316.56 572.86 317.29 573.55 313.2 577.94 309.11 573.55"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "140.48 207.55 140.48 311.93 95.63 311.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "98.95 307.84 99.63 308.58 96.02 311.93 99.63 315.29 98.95 316.02 94.55 311.93 98.95 307.84"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "140.48 467.2 140.48 359.29 95.63 359.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "98.95 355.2 99.63 355.93 96.02 359.29 99.63 362.65 98.95 363.38 94.55 359.29 98.95 355.2"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "530.75 207.55 530.75 311.93 575.6 311.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "572.28 316.02 571.6 315.29 575.21 311.94 571.6 308.58 572.28 307.85 576.68 311.94 572.28 316.02"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "530.75 467.2 530.75 359.29 575.6 359.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "572.28 363.38 571.6 362.65 575.21 359.29 571.6 355.94 572.28 355.2 576.68 359.29 572.28 363.38"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "outline"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m612.58,613.22H62.68V63.33h549.89v549.89h.01Zm-548.89-1h547.89V64.33H63.68v547.89h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m466.09,466.73H209.17V209.82h256.92v256.92h0Zm-255.92-1.01h254.92v-254.92h-254.92v254.92Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 538.33,
    y: 435.89,
    width: 1,
    height: 207.17,
    transform: "translate(-223.65 539.02) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 135.93,
    y: 33.49,
    width: 1,
    height: 207.17,
    transform: "translate(-56.97 136.62) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 32.84,
    y: 538.98,
    width: 207.17,
    height: 1,
    transform: "translate(-341.51 254.48) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 435.25,
    y: 136.57,
    width: 207.17,
    height: 1,
    transform: "translate(60.9 421.16) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m63.68,383.94H0v-91.34h63.68v91.34Zm-62.68-1h61.68v-89.34H1v89.34Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.5,
    y: 337.77,
    width: 62.68,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m675.26,383.94h-63.68v-91.34h63.68v91.34Zm-62.68-1h61.68v-89.34h-61.68v89.34Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 612.08,
    y: 337.77,
    width: 62.68,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m383.3,63.68h-91.34V0h91.34v63.68Zm-90.34-1h89.34V1h-89.34v61.68Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 337.13,
    y: 0.5,
    width: 1,
    height: 62.68
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m383.3,676.6h-91.34v-63.68h91.34v63.68Zm-90.34-1h89.34v-61.68h-89.34v61.68Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 337.13,
    y: 613.42,
    width: 1,
    height: 62.68
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 337.63,
    cy: 338.27,
    r: 30.38
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModes);
export default __webpack_public_path__ + "static/media/modes.939a1962ead6c0624d18b1acd513c28d.svg";
export { ForwardRef as ReactComponent };